import React from 'react';
import GenericDialogue from 'src/components/Dialogue/Dialogue';
import Button from 'src/components/Button';
import Avatar from 'src/components/Avatar';
import FontAwesomeIcon from 'src/components/Icon/FontAwesomeIcon';
import BulkSummaryHeader from 'src/components/BulkOperations/_Shared/BulkSummaryHeader/BulkSummaryHeader';
import SrDetailContact from 'src/pages/ServiceRequest/components/SrDetailContact/SrDetailContact';
import { PATHS } from 'src/common/constants';
import calcomLogo from '../../calcom-logo.svg';
import { IUnitKeyPickupStatus } from '../../types';
import './key-pickup-invite-dialog.scss';

interface KeyPickupInviteConfirmationProps {
  propertyId: string;
  invitedUnits: IUnitKeyPickupStatus[];
  onClose: () => void;
}

const KeyPickupInviteConfirmation = ({
  propertyId,
  invitedUnits,
  onClose,
}: KeyPickupInviteConfirmationProps) => {
  const invitedCount: number = invitedUnits.length;

  const buildUnitUrl = (unitId: string): string =>
    `${window.location.origin}${PATHS.SUITES_VIEW.replace(
      ':id',
      `${propertyId}&${unitId}`
    )}`;

  return (
    <GenericDialogue
      isOpen
      onClose={onClose}
      title="Key pickups"
      maxWidth="70rem"
      footer={
        <div className="key-pickup-invite-footer">
          <Button color="teal" size="small" label="Done" onClick={onClose} />
        </div>
      }
    >
      <div className="key-pickup-invite-confirmation">
        <BulkSummaryHeader
          title="Key-pickup invites sent"
          subtitle={
            <span>
              <strong>{invitedCount}</strong> invite
              {invitedCount === 1 ? '' : 's'} on the way. Each homeowner receives
              a Juniper-branded email with a &ldquo;Book your key pickup&rdquo;
              button — clicking it opens your linked Cal.com scheduler, where
              they pick a pickup time from your live availability.
            </span>
          }
        />

        <div className="confirmation-brand">
          <span className="confirmation-brand-label">
            Scheduling powered by
          </span>
          <img
            src={calcomLogo}
            className="confirmation-brand-logo"
            alt="Cal.com"
          />
        </div>

        <ul className="confirmation-units">
          {invitedUnits.map((unit: IUnitKeyPickupStatus) => (
            <li key={unit.unitId} className="confirmation-unit">
              <SrDetailContact
                name={unit.homeOwnerFullName || '—'}
                role={`Unit ${unit.number}`}
                avatar={<Avatar url={null} badge={undefined} size={undefined} />}
              />
              <a
                className="confirmation-unit-cta"
                href={buildUnitUrl(unit.unitId)}
                target="_blank"
                rel="noopener noreferrer"
              >
                View unit
                <FontAwesomeIcon
                  glyph="external-link"
                  weight="light"
                  size="small"
                />
              </a>
            </li>
          ))}
        </ul>
      </div>
    </GenericDialogue>
  );
};

export default KeyPickupInviteConfirmation;